"use strict";

define('model/report',['backbone', './base', 'datakit/util/url'], function (Backbone, BaseModel, url) {
  var Report = BaseModel.extend({
    urlRoot: '/rs/api/report',
    childModels: {
      'author': 'Person',
      'type': 'ReportType'
    },
    virtual: {
      'authorDisplayName': BaseModel.createKeyPathVirtual('author.displayName'),
      'columns': function columns() {
        var data = this.get('data');
        return data ? JSON.parse(data).columns || {} : {};
      },
      'filters': function filters() {
        var data = this.get('data');
        var filtersAsPlainObject = this.convertFiltersToPlainObject(JSON.parse(data).filters || {});
        return data ? filtersAsPlainObject : {};
      }
    },
    defaults: {
      'data': '{}',
      'name': ''
    },
    validation: {
      name: {
        required: true,
        maxLength: 50
      }
    },
    convertFiltersToPlainObject: function convertFiltersToPlainObject(jsonObject) {
      if (!jsonObject || Object.keys(jsonObject).length === 0) return {};
      function convertFilterValues(values) {
        var valueStr = "";
        values.forEach(function (value) {
          if (valueStr) {
            valueStr += ",";
          }
          valueStr += value.value;
        });
        return valueStr;
      }
      var filterPlain = {};
      jsonObject.forEach(function (filter) {
        if (filter.dateType) {
          filterPlain[filter.columnName] = {
            dateType: 'true',
            fromDate: filter.fromDate,
            toDate: filter.toDate
          };
        } else {
          filterPlain[filter.columnName] = convertFilterValues(filter.values);
        }
      });
      return filterPlain;
    },
    generateDownloadUrl: function generateDownloadUrl(type) {
      switch (type) {
        case 'csv':
        default:
          return url.template('/rs/api/report/:id/result', this);
      }
    },
    runReportUrl: function runReportUrl(isSystemReport) {
      var urlPath = url.template(isSystemReport ? '/rs/api/report/async/systemGenerated/:id' : '/rs/api/report/async/:id', this);
      var requestBody = isSystemReport ? {
        url: urlPath,
        type: 'PUT',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(this.get('formData'))
      } : {
        url: urlPath,
        type: 'PUT'
      };
      return this.request(requestBody);
    },
    createNewSystemReport: function createNewSystemReport(data) {
      var urlPath = url.template('/rs/api/report');
      var requestBody = {
        url: urlPath,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data)
      };
      return this.request(requestBody);
    },
    getReportStatusUrl: function getReportStatusUrl(noRetries) {
      var statusUrl = url.template('/rs/api/report/async/:id/status', this);
      var statusCheckInterval = 5000;
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(this.request({
            url: statusUrl,
            type: 'Get'
          }));
        }.bind(this), statusCheckInterval);
      }.bind(this)).then(function (result) {
        if (result.data === true) {
          return Promise.resolve();
        }
        if (noRetries === 0) {
          return Promise.reject('Report download timeout!');
        } else {
          return this.getReportStatusUrl(noRetries - 1);
        }
      }.bind(this));
    },
    downloadReportUrl: function downloadReportUrl(isSystemReport) {
      return url.template(isSystemReport ? '/rs/api/report/async/systemGenerated/:id/result' : '/rs/api/report/async/:id/result', this);
    },
    generateDefinitionResults: function generateDefinitionResults() {
      var url = '/rs/api/report/result',
        def = new BaseModel({
          data: this.get('data'),
          type: this.get('type')
        });
      return BaseModel.prototype.sync.call(this, 'create', def, {
        url: url
      });
    },
    getStudyStatus: function getStudyStatus() {
      return this.fetch({
        url: url.template('/rs/api/studyStatus/getAll', this)
      });
    },
    getStudySponsor: function getStudySponsor() {
      return this.fetch({
        url: url.template('/rs/api/sponsor/getAll', this)
      });
    },
    getLookupValues: function getLookupValues(val) {
      return this.fetch({
        url: url.template("/rs/api/".concat(val, "/getAll"), this)
      });
    },
    setColumns: function setColumns(columns) {
      var data = this.get('data');
      data = data ? JSON.parse(data) : {};
      data.columns = columns;
      this.set('data', JSON.stringify(data));
    },
    setFilters: function setFilters(filters) {
      var filtersModelCollection = this.convertJsonObjectToModelCollection(filters);
      var data = this.get('data');
      data = data ? JSON.parse(data) : {};
      data.filters = filtersModelCollection;
      this.set('data', JSON.stringify(data));
    },
    convertJsonObjectToModelCollection: function convertJsonObjectToModelCollection(filters) {
      var that = this;
      var collection = new Backbone.Collection();
      Object.keys(filters).forEach(function (key) {
        var valueObj = filters[key];
        if (!valueObj) {
          return;
        }
        var filter;
        if (valueObj.dateType) {
          filter = {
            columnName: key,
            dateType: 'true',
            fromDate: valueObj.fromDate,
            toDate: valueObj.toDate
          };
        } else {
          filter = {
            columnName: key,
            values: that.splitValue(filters[key])
          };
        }
        collection.add(filter);
      });
      return collection;
    },
    splitValue: function splitValue(joinedValues) {
      var arr = [];
      joinedValues.split("|").forEach(function (value) {
        arr.push({
          value: value ? decodeURIComponent(value) : value
        });
      });
      return arr;
    }
  }, {
    all: function all() {
      return this.createCollection('/rs/api/report');
    }
  });
  return Report;
});

